export const TraderList = [75];

export const CompanyCheck = [88, 82, 90];

export const StateCheck = [24];

export const gridcoMargin = 105;
export const gridcoMarginGenerator = 20;
